export default __webpack_public_path__ + "static/media/More.188bf092.svg";